<template>
    <div>
        <div class="budget" v-if="!loading">
            Tryk udenfor input-feltet, når du har indtastet et beløb, for at gemme budgettet.
            <br><br>
            Scroll til højre på skærmen for at se alle månederne.
            <br><br>

            <div class="placeholder padding" style="overflow-x:scroll;margin-bottom:15px;" v-for="accountCategory in accountCategories" :key="accountCategory.slug" v-if="accountCategories.length > 0">
                <div class="title">
                    {{ accountCategory.name }}
                </div>
                <table v-if="accountCategory.accounts.length > 0">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th class="name">Konto</th>
                            <th>Jan</th>
                            <th>Feb</th>
                            <th>Mar</th>
                            <th>Apr</th>
                            <th>Maj</th>
                            <th>Jun</th>
                            <th>Jul</th>
                            <th>Aug</th>
                            <th>Sep</th>
                            <th>Okt</th>
                            <th>Nov</th>
                            <th>Dec</th>
                            <th class="totals">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="account in accountCategory.accounts" :key="account.uuid">
                            <td>{{ account.account_number }}</td>
                            <td class="name">{{ account.name }}</td>
                            <td><input type="text" v-model="account.budgets.january" @blur="updateValue(account.uuid, 'january', account.budgets.january)" /></td>
                            <td><input type="text" v-model="account.budgets.february" @blur="updateValue(account.uuid, 'february', account.budgets.february)" /></td>
                            <td><input type="text" v-model="account.budgets.march" @blur="updateValue(account.uuid, 'march', account.budgets.march)" /></td>
                            <td><input type="text" v-model="account.budgets.april" @blur="updateValue(account.uuid, 'april', account.budgets.april)" /></td>
                            <td><input type="text" v-model="account.budgets.may" @blur="updateValue(account.uuid, 'may', account.budgets.may)" /></td>
                            <td><input type="text" v-model="account.budgets.june" @blur="updateValue(account.uuid, 'june', account.budgets.june)" /></td>
                            <td><input type="text" v-model="account.budgets.july" @blur="updateValue(account.uuid, 'july', account.budgets.july)" /></td>
                            <td><input type="text" v-model="account.budgets.august" @blur="updateValue(account.uuid, 'august', account.budgets.august)" /></td>
                            <td><input type="text" v-model="account.budgets.september" @blur="updateValue(account.uuid, 'september', account.budgets.september)" /></td>
                            <td><input type="text" v-model="account.budgets.october" @blur="updateValue(account.uuid, 'october', account.budgets.october)" /></td>
                            <td><input type="text" v-model="account.budgets.november" @blur="updateValue(account.uuid, 'november', account.budgets.november)" /></td>
                            <td><input type="text" v-model="account.budgets.december" @blur="updateValue(account.uuid, 'december', account.budgets.december)" /></td>
                            <td class="totals">
                                {{ Number(account.budgets.january) + Number(account.budgets.february) + Number(account.budgets.march) + Number(account.budgets.april) + Number(account.budgets.may) + Number(account.budgets.june) + Number(account.budgets.july) + Number(account.budgets.august) + Number(account.budgets.september) + Number(account.budgets.october) + Number(account.budgets.november) + Number(account.budgets.december) | currency }}
                            </td>
                        </tr>
                        <tr class="totals">
                            <td></td>
                            <td class="name">Total</td>
                            <td>
                                {{ count = null }}
                                {{ accountCategory.accounts.forEach((account) => {count = Number(count + Number(account.budgets.january))}) }}
                                {{ count | currency }}
                            </td>
                            <td>
                                {{ count = null }}
                                {{ accountCategory.accounts.forEach((account) => {count = Number(count + Number(account.budgets.february))}) }}
                                {{ count | currency }}
                            </td>
                            <td>
                                {{ count = null }}
                                {{ accountCategory.accounts.forEach((account) => {count = Number(count + Number(account.budgets.march))}) }}
                                {{ count | currency }}
                            </td>
                            <td>
                                {{ count = null }}
                                {{ accountCategory.accounts.forEach((account) => {count = Number(count + Number(account.budgets.april))}) }}
                                {{ count | currency }}
                            </td>
                            <td>
                                {{ count = null }}
                                {{ accountCategory.accounts.forEach((account) => {count = Number(count + Number(account.budgets.may))}) }}
                                {{ count | currency }}
                            </td>
                            <td>
                                {{ count = null }}
                                {{ accountCategory.accounts.forEach((account) => {count = Number(count + Number(account.budgets.june))}) }}
                                {{ count | currency }}
                            </td>
                            <td>
                                {{ count = null }}
                                {{ accountCategory.accounts.forEach((account) => {count = Number(count + Number(account.budgets.july))}) }}
                                {{ count | currency }}
                            </td>
                            <td>
                                {{ count = null }}
                                {{ accountCategory.accounts.forEach((account) => {count = Number(count + Number(account.budgets.august))}) }}
                                {{ count | currency }}
                            </td>
                            <td>
                                {{ count = null }}
                                {{ accountCategory.accounts.forEach((account) => {count = Number(count + Number(account.budgets.september))}) }}
                                {{ count | currency }}
                            </td>
                            <td>
                                {{ count = null }}
                                {{ accountCategory.accounts.forEach((account) => {count = Number(count + Number(account.budgets.october))}) }}
                                {{ count | currency }}
                            </td>
                            <td>
                                {{ count = null }}
                                {{ accountCategory.accounts.forEach((account) => {count = Number(count + Number(account.budgets.november))}) }}
                                {{ count | currency }}
                            </td>
                            <td>
                                {{ count = null }}
                                {{ accountCategory.accounts.forEach((account) => {count = Number(count + Number(account.budgets.december))}) }}
                                {{ count | currency }}
                            </td>
                            <td>
                                {{ count = null }}
                                {{ accountCategory.accounts.forEach((account) => {count = count + Number(account.budgets.january) + Number(account.budgets.february) + Number(account.budgets.march) + Number(account.budgets.april) + Number(account.budgets.may) + Number(account.budgets.june) + Number(account.budgets.july) + Number(account.budgets.august) + Number(account.budgets.september) + Number(account.budgets.october) + Number(account.budgets.november) + Number(account.budgets.december)}) }}
                                {{ count | currency }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-else>
                    Ingen konti i denne kategori
                </div>
            </div>
        </div>

        <box-loading height="350" v-else />

    </div>
</template>

<style lang="scss" scoped>

    .title {
        margin-bottom: 15px;
    }

    table {
        text-align: left;

        th, td {
            min-width: 100px;
            padding: 5px 15px 5px 0px;

            &.name {
                min-width: 200px;
            }
        }

        input {
            border: 1px solid #ccc;
            border-radius: 4px;
            padding: 4px 8px;
            width: 100%;
        }

        .totals {
            font-weight: bold;
        }
    }

</style>

<script>
import * as economyService from '@/services/economyService'

export default {
    data () {
        return {
            loading: true,
            accountCategories: null,
            budgetCalc: null
        }
    },
    mounted () {
        this.getAccountCategories()
    },
    methods: {
        getAccountCategories () {
            economyService.accountCategories({}, (response) => {
                this.accountCategories = response.data
                this.loading = false
            }, (err) => {
                console.log(err)
            })
        },
        updateValue (uuid, month, value) {
            let body = {
                ['budget_' + month]: value
            }
            economyService.updateAccount(uuid, body, (response) => {
                // this.$toastr('success', 'Budgettet blev opdateret', 'Sådan!')
            }, (err) => {
                console.log(err)
                this.$toastr('error', 'Der skete en fejl ved opdatering af budgettet', 'Hovsa!')
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// budget.vue?676794b6